
  import { Component, Prop, Vue } from 'vue-property-decorator'

  @Component
  export default class LabeledValue extends Vue {
    @Prop({ type: String, required: true })
    public label!: string
  }
